import React from 'react';
import SectionHeader from '../../../common/marketing/SectionHeader';
import OrbitStarVariantPicker from './OrbitStarVariantPicker';

const OrbitStarVariantsSection = ({ section }) => (
    <section id="variants" className="orbit-star-variants">
        <div className="container">
            <SectionHeader
                wrapperClassName="orbit-star-section-header"
                subtitleClassName="orbit-star-section-subtitle"
                titleClassName="orbit-star-section-title orbit-star-section-title--light"
                descriptionClassName="orbit-star-variants-intro"
                subtitle={section.subtitle}
                title={section.title}
                description={section.description}
            />
            <OrbitStarVariantPicker section={section} syncWithUrl />
        </div>
    </section>
);

export default OrbitStarVariantsSection;
